<template>
  <div class="login-container">
    <card class="mb-0">
      <h5>Hey there,</h5>
      <p>We need some more details to get you up and running.</p>
      <b-form @submit.prevent="submit">
        <fg-input
          name="businessName"
          label="Business Name"
          v-model="formData.businessName"
        />
        <fg-input
          name="businessAddress"
          label="Business Address"
          v-model="formData.businessAddress"
        />
        <n-button
          type="info"
          native-type="submit"
          class="mt-4"
          :busy="submitting"
          block
        >
          Continue
        </n-button>
      </b-form>
    </card>
    <div class="text-center">
      <n-button link class="text-muted" @click.native="doLogout">
         Go back
      </n-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      submitting: false,
      formData: {
        businessName: '',
        businessAddress: ''
      }
    };
  },
  methods: {
    ...mapActions(["activateUserAccount", "logout"]),
    async submit() {
      this.submitting = true;

      try {
        await this.activateUserAccount(this.formData);
        this.$router.push("/");
      } catch (error) {
        this.submitting = false;
        this.$notify({
          type: "danger",
          title: this.$t("message.error"),
          text: error.message
        });
      }
    },
    async doLogout() {
      try {
        await this.logout();
      } catch (e) {}
      finally {
        this.$router.push('/auth/login');
      }
    }
  },
  computed: mapGetters(['userSetupCompleted']),
  created() {
    this.$router.replace("/start");
  }
};
</script>
<style lang="scss" scoped>
  .login-container {
    width: auto;
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 60%;
      margin-bottom: 3em;
    }
  }
</style>
